import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { StyledRadio, RadioLabel, RadioContainer, Description, styledSystemKeys } from "./radioButton.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RadioButton = function RadioButton(props) {
  var id = props.id,
    label = props.label,
    checked = props.checked,
    onChange = props.onChange,
    align = props.align,
    name = props.name,
    disabled = props.disabled,
    hideLabel = props.hideLabel,
    className = props.className,
    ellipse = props.ellipse,
    accessibleLabel = props.accessibleLabel,
    maxLabelWidth = props.maxLabelWidth;
  var radioMarkup = /*#__PURE__*/_jsx(StyledRadio, {
    id: id,
    type: "radio",
    checked: checked,
    name: name,
    disabled: disabled,
    hideLabel: hideLabel,
    onChange: onChange,
    "aria-describedby": "describe-".concat(id)
  });
  var adjustedLabelStyles = align === "right" ? {
    width: "calc(100% - 24px)",
    margin: "auto 0"
  } : {};
  var labelMarkup = /*#__PURE__*/_jsx(RadioLabel, {
    htmlFor: id,
    disabled: disabled,
    hideLabel: hideLabel,
    ellipse: ellipse,
    style: adjustedLabelStyles,
    maxWidth: maxLabelWidth,
    children: label
  });
  return /*#__PURE__*/_jsxs(RadioContainer, _objectSpread(_objectSpread({
    className: className,
    checked: checked,
    disabled: disabled,
    hideLabel: hideLabel,
    title: label
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [accessibleLabel && /*#__PURE__*/_jsx(Description, {
      id: "describe-".concat(id),
      children: accessibleLabel
    }), align === "right" ? labelMarkup : radioMarkup, align === "right" ? radioMarkup : labelMarkup]
  }));
};
RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.oneOf([true, false]),
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  align: PropTypes.string,
  className: PropTypes.string,
  accessibleLabel: PropTypes.string
};
export default RadioButton;